// extracted by mini-css-extract-plugin
export default {"title":"Identity_title__Ivkul","mid-box":"Identity_mid-box__8EcX+","i-pin":"Identity_i-pin__lbODL"};